<template>
  <div class="Edit-Profile">
    <div class="Header-Edit-Profile">
      <h1>Password</h1>
    </div>
    <FormChangePasswordVue />
  </div>
</template>

<script>
import FormChangePasswordVue from "./FormChangePassword.vue";
export default {
  components: {
    FormChangePasswordVue,
  },
};
</script>

<style>
.form-Edit-Profile {
  width: 50%;
  margin: 0 auto;
}
</style>